<template>
  <div class="app-container">
    <!-- 基础信息 -->
    <BjDivider right-fixed>{{ $t('goodsSku.detail.BasicInformation') }}
      <template slot="right">
        <template v-if="isAdd && !type">
          <el-button @click="tryCancel">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="handleConfirm(false)">{{ $t('saveText') }}</el-button>
        </template>
        <template v-if="isView">
          <el-button type="primary" @click="cancel">{{ $t('backText') }}</el-button>
          <el-button v-if="!$store.getters.cusId" type="primary" @click="showLog">{{$t('BusinessPurchaseApplyDetail.operationLog') }}</el-button>
        </template>
      </template>
    </BjDivider>
    <el-form ref="form" :model="goodsData" :rules="rules" label-width="230px" class="form" :disabled="!!type">
      <el-row>
        <!-- sku名称 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.skuName')" prop="skuName">
            <BjInput v-model="goodsData.skuName" autosize :maxlength="MAX_LENGTH.REMARK" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <!-- sku编码 -->
        <el-col v-if="$route.query.id" :span="colSpan">
          <el-form-item :label="$t('goodsPage.skuCode')" prop="skuCode">
            <BjInput v-model="goodsData.standardSkuCode" :disabled="!!$route.query.id" autosize :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col v-else :span="colSpan">
          <el-form-item :label="$t('goodsPage.skuCode')" prop="skuCode">
            <BjInput v-model="goodsData.skuCode" :disabled="!!$route.query.id" autosize :maxlength="MAX_LENGTH.NORMAL" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <!-- 商品类型 -->
        <!-- <el-col :span="colSpan">
          <el-form-item :label="$t('BjDialogListConfig.Producttype')" prop="itemType">
            <BjSelectLov v-model="goodsData.itemType" :disabled="true" :option-list="ITEM_TYPE_CHOOSE" :placeholder="$t('chooseText')" />
          </el-form-item>
        </el-col> -->
        <!-- 是否需要批次和过期日期功能 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.need')" prop="needExpired">
            <el-switch v-model="goodsData.needExpired" active-color="#082dc3" inactive-color=""></el-switch>
          </el-form-item>
        </el-col>
        <!-- 条形码 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.Barcode') " prop="barCode">
            <label slot="label">{{$t('goodsSku.detail.Barcode')}}
              <el-tooltip effect="dark" :content="$t('goodsSku.detail.barcodeTip')" placement="top">
                <i class="el-icon-question" style="color:#4d08ed;"></i>
              </el-tooltip>
            </label>
            <!-- 有库存 user禁止修改 admin允许修改 -->
            <BjInput :disabled="barCodeDisStatus" v-model="goodsData.barCode" :maxlength="14" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <!-- 成本价 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.costPrice')" prop="costPrice">
            <BjInputMoney v-model="goodsData.costPrice" :placeholder="$t('goodsPage.costPrice')" clearable />
          </el-form-item>
        </el-col>
        <!-- 序列号 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.Serial')" prop="needSerialNo">
            <el-switch v-model="goodsData.needSerialNo" active-color="#082dc3" inactive-color=""></el-switch>
          </el-form-item>
        </el-col>
        <!-- 每箱件数  item per carton  -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.itemPerCarton')" prop="qty">
            <BjInputNumber v-model="goodsData.qty" :min="1" />
          </el-form-item>
        </el-col>
        <!-- 是否酒水 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.isWine')" prop="fragile">
            <BjSelectLov v-model="goodsData.fragile" :option-list="STATUS_YES_NUMBER" :placeholder="$t('chooseText')" />
          </el-form-item>
        </el-col>
        <!-- 危险品 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.dangerousGoods')" prop="dangerousGoods">
            <el-switch v-model="goodsData.dangerousGoods" active-color="#082dc3" inactive-color=""></el-switch>
          </el-form-item>
        </el-col>
        <!-- 原产地 -->
        <!-- 'TW','HK','MO','SG','GB','IE','IL','IS','AE','MC','BH','VA','SZ','MV','NZ','SM','LI','AD','BS' -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.originPlace')" prop="originPlace">
            <BjSelectLov v-model="goodsData.originPlace" :option-list="COUNTRY_NAME_AND_TWOCODE" :placeholder="$t('chooseText')" />
          </el-form-item>
        </el-col>
        <!-- HS CODE -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.hsCode')" prop="hsCode">
            <BjInput v-model="goodsData.hsCode" :maxlength="14" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <!-- 描述 -->
        <el-col :span="colSpan*2">
          <el-form-item :label="$t('goodsSku.detail.skuDesc')" prop="skuDesc">
            <BjInput v-model="goodsData.skuDesc" type="textarea" show-word-limit autosize :maxlength="MAX_LENGTH.PRIORITY" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 属性表 -->
      <BjDivider style="margin-top:20px;">{{ $t('goodsSku.detail.AttributeTable') }}</BjDivider>
      <el-row>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.length')" prop="length">
            <BjInputMoney v-model="goodsData.length">
              <template slot="append">cm</template>
            </BjInputMoney>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.width')" prop="width">
            <BjInputMoney v-model="goodsData.width">
              <template slot="append">cm</template>
            </BjInputMoney>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.height')" prop="height">
            <BjInputMoney v-model="goodsData.height">
              <template slot="append">cm</template>
            </BjInputMoney>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.weight')" prop="weight">
            <BjInputMoney v-model="goodsData.weight">
              <template slot="append">kg</template>
            </BjInputMoney>
          </el-form-item>
        </el-col>

        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.cartonLength')" prop="cartonLength" :rules="goodsData.qty>1 ? rules.cartonLength : [{required: false}]">
            <BjInputMoney v-model="goodsData.cartonLength">
              <template slot="append">cm</template>
            </BjInputMoney>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.cartonWidth')" prop="cartonWidth" :rules="goodsData.qty>1 ? rules.cartonWidth : [{required: false}]">
            <BjInputMoney v-model="goodsData.cartonWidth">
              <template slot="append">cm</template>
            </BjInputMoney>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.cartonHeight')" prop="cartonHeight" :rules="goodsData.qty>1 ? rules.cartonHeight : [{required: false}]">
            <BjInputMoney v-model="goodsData.cartonHeight">
              <template slot="append">cm</template>
            </BjInputMoney>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsSku.detail.cartonWeight')" prop="cartonWeight" :rules="goodsData.qty>1 ? rules.cartonWeight : [{required: false}]">
            <BjInputMoney v-model="goodsData.cartonWeight">
              <template slot="append">kg</template>
            </BjInputMoney>
          </el-form-item>
        </el-col>
      </el-row>

    
      <!-- 包材信息 -->
      <template v-if="goodsData.itemType == 'item'&& this.$store.state.user.permissionBtns.includes('BusinessGoodsPackageManagement'.toLocaleLowerCase())"> 
        <BjDivider style="margin-top:20px;" v-if="isAdd && !type || isView">{{ $t('goodsPage.package.Info') }}</BjDivider>
        <el-row v-for="(item,index) in packageInfo.packageList" :key="index">
          <el-col :span="12">
            <el-form-item :label="index==0 ? $t('goodsPage.package.order'): $t('goodsPage.package.product')" prop="order">
              <el-input v-model="item.skuName" disabled :placeholder="$t('chooseText')">
                <template slot="append">
                  <!-- :disabled="isView"  -->
                  <el-button :disabled="!$store.getters.cusId" type="primary" @click="choosePackage(index)">{{ $t('goodsPage.package.Selectpackagingmaterials') }}</el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-button :disabled="!$store.getters.cusId" type="text" style="margin-left:10px;" class="delete-btn" @click="onDelete(index)">{{ $t('delText') }}</el-button>
        </el-row>
      </template>

      <BjDialogList ref="BjDialogPackageList" width="80%" :config="$BjDialogListConfig.packageDefault($t('goodsPage.package.Selectpackagingmaterials'), { defaultQuery})" @confirm="confirmDialogList" />

      <BjDivider style="margin-top:20px;">{{ $t('goodsPage.rule') }}</BjDivider>
      <el-row>
        <skuRule />
      </el-row>
    </el-form>
  </div>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import { goodsApi,commonApi, promotionApi } from '@/api';
import orderLog from '@/utils/log.js';
import {
  ITEM_TYPE_CHOOSE,
  STATUS_YES_NUMBER,
  PACKAGE_TYPE_LIST
} from '@/utils/constants';
import skuRule from './skuRule.vue';
import label from '@/router/center-setting/label';
import { COUNTRY_NAME_AND_TWOCODE } from '@/utils/statics';

const DIMENSION_SIDE_LIMIT = 120;
const DIMENSION_SUM_LIMIT = 200;
const obj = {   
  skuCode: null, skuName: null, itemType:null, barCode: null, packingMethod: null, packageType: null, salesPrice: null, activityPrice: null, fullNum: null, giftNum: null, giftCondition: null,
}
export default {
  components: {
    skuRule
  },
  mixins: [viewMiXin],
  props: {
    isAdd: {
      type: Boolean,
      default: true,
    },
    isView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const validateValue = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error(this.$t('goodsSku.detail.valueDa')));
      } else {
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      this.$nextTick(() => {
        if (!value) {
          callback(new Error(this.$t('inputText')));
        }
        callback();
      });
    };
    return {
      colSpan: 8,
      COUNTRY_NAME_AND_TWOCODE,
      defaultQuery: { 'itemType': 'package box', 'selectType': 2, 'cusId': this.$store.getters.cusId },
      ITEM_TYPE_CHOOSE,
      STATUS_YES_NUMBER,
      PACKAGE_TYPE_LIST,
      type: this.$route.query.type || null,
      goodsData: {
        id: this.$route.query.id || null,
        skuName: '',
        skuCode: '',
        standardSkuCode: '',
        barCode: '',
        itemType: 'item',
        itemPerCarton: 1,
        skuDesc: '',
        costPrice: '0.00',
        fragile: 0,
        needExpired: false,
        needSerialNo: false,
        dangerousGoods: false,

        length: '0.00',
        width: '0.00',
        height: '0.00',
        weight: '0.00',
        qty: 1,
        cartonLength: '0.00',
        cartonWidth: '0.00',
        cartonHeight: '0.00',
        cartonWeight: '0.00',
        volumeUnit: '0.00',
      },
      rules: {
        skuCode: [{ required: true, validator: validateCode, trigger: 'blur' }],
        skuName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        // barCode: [{ required: true, validator: validateBarcode, trigger: 'blur' }],
        itemType: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        costPrice: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],

        qty: [{ required: true, validator: validateValue, trigger: 'blur' }],
        length: [{ required: true, validator: validateValue, trigger: 'blur' }],
        width: [{ required: true, validator: validateValue, trigger: 'blur' }],
        height: [{ required: true, validator: validateValue, trigger: 'blur' }],
        weight: [{ required: true, validator: validateValue, trigger: 'blur' }],
        // qty: [{ required: true, validator: validateValue, trigger: 'blur' }],
        cartonLength: [{ required: true, validator: validateValue, trigger: 'blur' }],
        cartonWidth: [{ required: true, validator: validateValue, trigger: 'blur' }],
        cartonHeight: [{ required: true, validator: validateValue, trigger: 'blur' }],
        cartonWeight: [{ required: true, validator: validateValue, trigger: 'blur' }],
      },
      ROLE_LIST: [],
      ROLE_USER_LIST: [],
      BRAND_LIST: [],
      COUNTRY_CODE_LIST: [],
      switchBtn: false,
      packageInfo: {
       // cusId: this.$store.getters.cusId || null,
        packageList:[{ ...obj, skuName: '', packingMethod: 'order'}, { ...obj, skuName: '', packingMethod: 'product'}],
      },
      TypeOption: [
        { label: this.$t('goodsPage.package.csg'), value: 'csg' },
        { label: this.$t('goodsPage.package.cus'), value: 'cus' },
      ],
      chooseIndex:0
    };
  },
  watch: {
    'goodsData.length'(val) {
      if (this.goodsData.qty == 1 && !this.goodsData.id) {
        this.goodsData.cartonLength = val;
      }
    },
    'goodsData.width'(val) {
      if (this.goodsData.qty == 1 && !this.goodsData.id) {
        this.goodsData.cartonWidth = val;
      }
    },
    'goodsData.height'(val) {
      if (this.goodsData.qty == 1 && !this.goodsData.id) {
        this.goodsData.cartonHeight = val;
      }
    },
    'goodsData.weight'(val) {
      if (this.goodsData.qty == 1 && !this.goodsData.id) {
        this.goodsData.cartonWeight = val;
      }
    }, 
  },
  computed:{
    tableList(){
      return this.packageInfo.packageList.filter(item=> item.skuName)
    },
    barCodeDisStatus(){
      if(this.goodsData.inStock){
        if(this.$store.getters.cusId){
          return true
        }
        if(!this.$store.getters.cusId){
          return false
        }
      }else{
        return false
      }
    },
  },
  created() {
    if (this.goodsData.id) {
      this.getGoodsDetailData();
    }
    // this.getCountryCodeList()
  },
  methods: {
    getCountryCodeList(){
      const country = [
        'AF','AX','AL','DZ','AS','AD','AO','AI','AQ','AG','AR','AM','AW','AU','AT','AZ',
        'BS','BH','BD','BB','BY','BE','BZ','BJ','BM','BT','BO','BQ','BA','BW','BV','BR',
        'IO','BN','BG','BF','BI','CV','KH','CM','CA','KY','CF','TD','CL','CN','CX','CC',
        'CO','KM','CD','CG','CK','CR','CI','HR','CU','CW','CY','CZ','DK','DJ','DM','DO',
        'EC','EG','SV','GQ','ER','EE','ET','FK','FO','FJ','FI','FR','GF','PF','TF','GA',
        'GM','GE','DE','GH','GI','GR','GL','GD','GP','GU','GT','GG','GN','GW','GY','HT',
        'HM','VA','HN','HK','HU','IS','IN','ID','IR','IQ','IE','IM','IL','IT','JM','JP',
        'JE','JO','KZ','KE','KI','KP','KR','KW','KG','LA','LV','LB','LS','LR','LY','LI',
        'LT','LU','MO','MK','MG','MW','MY','MV','ML','MT','MH','MQ','MR','MU','YT','MX',
        'FM','MD','MC','MN','ME','MS','MA','MZ','MM','NA','NR','NP','NL','NC','NZ','NI',
        'NE','NG','NU','NF','MK','MP','NO','OM','PK','PW','PS','PA','PG','PY','PE','PH',
        'PN','PL','PT','PR','QA','RE','RO','RU','RW','BL','SH','KN','LC','MF','PM','VC',
        'WS','SM','ST','SA','SN','RS','SC','SL','SG','SX','SK','SI','SB','SO','ZA','GS',
        'SS','ES','LK','SD','SR','SJ','SE','CH','SY','TW','TJ','TZ','TH','TL','TG','TK',
        'TO','TL','TN','TR','TM','TC','TV','UG','UA','AE','GB','US','UM','UY','UZ','VU',
        'VE','VN','VG','VI','WF','EH','YE','ZM','ZW'
      ]
      this.COUNTRY_CODE_LIST = country.map(e => ({label:e,value:e}))
    },
    onDelete(index){
      this.packageInfo.packageList.forEach((jitem,jindex)=>{
        if(index == jindex){
          this.$set(jitem, 'skuName', null)
        }
      })
      this.$nextTick(()=>{
        this.$forceUpdate();
      })
    },
    choosePackage(val){
      this.chooseIndex = val
      this.defaultQuery = {...this.defaultQuery}
      setTimeout(()=>{ this.$refs.BjDialogPackageList.show(); },500)
    },
    confirmDialogList(data){
      data.forEach(item => {
        const {skuCode, skuName, itemType, barCode, packingMethod, packageType, salesPrice, activityPrice} = item
        this.packageInfo.packageList.forEach((jitem,jindex)=>{
          if( this.chooseIndex == jindex){
            this.packageInfo.packageList[jindex] = {
              skuCode, skuName, itemType, barCode, packingMethod: this.chooseIndex == 0? 'order':'product', packageType, salesPrice, activityPrice, fullNum: 1, giftNum: 1, giftCondition: packingMethod == 'order' ? 0:1
            }
          }
        })
      });

      this.packageInfo = {
        ...this.packageInfo,
        skuCode: this.goodsData.skuCode,
        skuName: this.goodsData.skuName,
        barCode: this.goodsData.barCode,
      }
    },
    showLog() {
      orderLog(
          this.$BjDialogListConfig['purchaseDefault'](`${this.$t('BusinessPurchaseApplyDetail.dialogText2')}`, {
              actionApi: commonApi.getLogPages,
              defaultQuery: {
                id: this.$route.query.id
              },
              columns: [
                {
                    prop: 'creationDate',
                    label: 'BjDialogListConfig.Operationtime',
                },
                {
                    prop: 'createdName',
                    label: 'BjDialogListConfig.Operator',
                },
                {
                    prop: 'remark',
                    label: 'BjDialogListConfig.Remarks',
                },
              ],
          }),
      );
    },
    async getGoodsDetailData() {
      const res = await goodsApi.detailSku({ id: this.$route.query.id });
      this.goodsData = {
        ...res,
        needExpired: !!res.needExpired,
        needSerialNo: !!res.needSerialNo,
        dangerousGoods: !!res.dangerousGoods,
      };
      promotionApi.selectByMainSkuCode([res.skuCode]).then(resp=>{
        if(resp.length == 0){
          this.packageInfo = { packageList:[{ ...obj, skuName: '', packingMethod: 'order'}, { ...obj, skuName: '', packingMethod: 'product'}] }
        }else{
          if(resp[0].packageList.length == 1){
            const packageList = resp[0].packageList.map(item=>{
              const { skuCode, skuName, itemType, barCode, packingMethod, packageType, salesPrice, activityPrice, fullNum, giftNum, giftCondition} = item
              return { skuCode, skuName, itemType, barCode, packingMethod, packageType, salesPrice, activityPrice, fullNum, giftNum, giftCondition}
            })
            packageList.forEach((item,index)=>{
              if(item.packingMethod == 'order'){
                this.packageInfo ={
                  ...resp[0],
                  packageList: [{ ...resp[0].packageList[index]}, { ...obj, skuName: '', packingMethod: 'product'}]
                }
              }else{
                this.packageInfo ={
                  ...resp[0],
                  packageList: [{ ...obj, skuName: '', packingMethod: 'order'}, { ...resp[0].packageList[index]}]
                }
              }
            })
          }else{
            const packageList = resp[0].packageList.map(item=>{
              const { skuCode, skuName, itemType, barCode, packingMethod, packageType, salesPrice, activityPrice, fullNum, giftNum, giftCondition} = item
              return { skuCode, skuName, itemType, barCode, packingMethod, packageType, salesPrice, activityPrice, fullNum, giftNum, giftCondition}
            }).sort((a, b) => {
              if (a.packingMethod == 'order') return -1;
              if (b.packingMethod == 'order') return 1;
              return 0;
            })
            this.packageInfo = { ...resp[0], packageList }
          }
        }
      })
    },
    beforeCofirm(){
      return new Promise((resolve) => {
        if(this.goodsData.itemType == 'item'){
          let apiName = ''
          const DATA = JSON.parse(JSON.stringify(this.packageInfo))
          DATA.packageList = DATA.packageList.filter(item=> item.skuName)
          if(DATA.id){
            apiName = 'updatePromotionGiftNewRules'
            promotionApi[apiName](DATA).then(res => {
              if (!res.failed) {
                resolve()
              }
            });
          }else if(DATA.packageList.length>0){
            apiName = 'addPromotionGiftNewRules'
            promotionApi[apiName](DATA).then(res => {
              if (!res.failed) {
                resolve()
              }
            });
          }else{
            resolve()
          }
        }else{
          resolve()
        }
      })
    },
    handleConfirm(flag) {
      const reg = /^[`~!@#$%^&*()_+<>?":| {}\/\[\]\\\-+=,.\/;'*0-9A-Za-z]*$/;
      if(!reg.test(this.goodsData.skuCode)) return this.$message.warning(`skuCode ${this.$t('formatErrorText')}`);
      if(this.goodsData.barCode && (/[^a-zA-Z0-9_#\[\]\(\)\-]/g.test(this.goodsData.barCode) || String(this.goodsData.barCode).length > 14)) return this.$message.warning(this.$t('ExcelConfig.tip3'))
 
      this.$refs.form.validate(valid => {
        if (valid) {
          const save = () => {
            if (this.goodsData.barCode) {
              goodsApi.checkBarCode({barCode: [this.goodsData.barCode], skuCode: [this.goodsData.skuCode]}).then(res => {
                if (!res.failed) {
                  this.toSave(flag);
                }
              });
            } else {
              this.toSave(flag);
            }
          };
          if (this.needOversizeDimensionConfirm()) {
            this.$confirm(this.$t('goodsSku.detail.oversizeDimensionConfirm'), this.$t('toast.hintText'), {
              confirmButtonText: this.$t('toast.okText'),
              cancelButtonText: this.$t('toast.cancelText'),
              type: 'warning',
              customClass: 'oversize-dimension-confirm'
            }).then(save).catch(() => {});
          } else {
            save();
          }
        }
      });
    },
    needOversizeDimensionConfirm() {
      const dimensions = [this.goodsData.length, this.goodsData.width, this.goodsData.height].map(item => Number(item) || 0);
      return dimensions.some(item => item >= DIMENSION_SIDE_LIMIT) ||
        dimensions.reduce((total, item) => total + item, 0) >= DIMENSION_SUM_LIMIT;
    },
    toSave(flag) {
      const obj = {
        ...this.goodsData,
        needExpired: this.goodsData.needExpired ? 1 : 0,
        needSerialNo: this.goodsData.needSerialNo ? 1 : 0,
        dangerousGoods: this.goodsData.dangerousGoods ? 1 : 0,
      };
      if (Number(obj.length) > Number(obj.cartonLength)) return this.$message.warning(`rule 8 error`);
      if (Number(obj.width) > Number(obj.cartonWidth)) return this.$message.warning(`rule 9 error`);
      if (Number(obj.height) > Number(obj.cartonHeight)) return this.$message.warning(`rule 10 error`);
      // if (Number((obj.length * obj.width * obj.height * obj.qty).toFixed(4)) > Number((obj.cartonLength * obj.cartonWidth * obj.cartonHeight).toFixed(4))) return this.$message.warning(`rule 11 error`);
      if (Number((obj.weight * obj.qty).toFixed(4)) > obj.cartonWeight) return this.$message.warning(`rule 11 error`);
      delete this.goodsData.fileRaw;
      if (this.goodsData.id) {
        goodsApi.updateSku({
          flag,
          sku: obj
        }).then(res => {
          if (!res.failed) {
            if(this.$store.getters.cusId){
              this.beforeCofirm().then(()=>{
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                this.complete('CSGGoodsSkuOrdinaryIndex');
              })
            }else{
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.complete('CSGGoodsSkuOrdinaryIndex');
            }
          }
        });
      } else {
        goodsApi.addSku({
          flag,
          setFlag: 0, // 0-单品，1-套餐
          skuList: [obj]
        }).then(res => {
          if (!res.failed) {
            this.beforeCofirm().then(()=>{
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.complete('CSGGoodsSkuOrdinaryIndex');
            })
          }
        });
      }
    },
  },
};
</script>
